var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{class:{'simple-modal': true, 'simple-modal_active': _vm.isMounted},on:{"click":function($event){if($event.target !== $event.currentTarget)return null;return _vm.destroyModal.apply(null, arguments)}}},[_c('div',{staticClass:"modal modal--light"},[_vm._t("default")],2)])
}
var staticRenderFns = []

export { render, staticRenderFns }